export default __webpack_public_path__ + "static/media/545.ff4ed09f.png";